import { Row } from "components/styles";
import MessageIcon from "icons/MessageIcon";
import { TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import { FieldIconWrapper } from "views/components/Schedules/styles";

const SpaceDetails = ({ details }) => {
	if (!details) return null;
	return (
		<Row width="100%" gap="10px" wrap="nowrap">
			<FieldIconWrapper>
				<MessageIcon size={16} />
			</FieldIconWrapper>
			<TextData 
				className="ellipsis" 
				title={details}>
				{details}
			</TextData>
		</Row>
	);
}

export default SpaceDetails;